// pages/Stands.js
import React, { useEffect } from 'react';
import Carousel from '../components/Carousel';

function Stands() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="stands-page">

    <div style={{
      padding: '80px 0 40px',
      textAlign: 'center',
      backgroundImage: 'url(/images/cover.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      position: 'relative',
      width: '100%',
      marginLeft: 'calc(-50vw + 50%)',
      minHeight: '400px'
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: 1
      }}></div>
      <div className="container" style={{ position: 'relative', zIndex: 2, padding: '0 20px' }}>

      <style jsx>{`
        @media (max-width: 768px) {
          .stands-page > div:first-child {
            padding: 60px 0 30px !important;
            min-height: 300px !important;
          }
          .stands-page h1 {
            font-size: 2.5rem !important;
          }
          .stands-page h3 {
            font-size: 1.4rem !important;
          }
        }
      `}</style>
      <img
        src="/images/Asset7.png"
        alt="Stands Icon"
        style={{
          width: '80px',
          height: '80px',
          objectFit: 'contain'
        }}
      />
      <h1 style={{
        fontSize: '3.5rem',
        marginBottom: '20px',
        background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text'
      }}>
      معارض وأروقة تفاعلية
      </h1>

      <h3 style={{
        fontSize: '2rem',
        marginBottom: '20px',
        fontWeight: '600',
        lineHeight: '1.6'
      }}>
        "مانسكتوش على العنف"

      </h3>
      </div>
    </div>

      {/* Context Section */}
      <div style={{ background: 'var(--secondary-black)', padding: '60px 0' }}>
        <div className="container">

          {/* Context Description */}
          <div style={{ marginBottom: '50px' }}>
            <h3 style={{
              fontSize: '2.3rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)'
            }}>
              السياق
            </h3>

            <div style={{
              background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.1), rgba(255, 133, 85, 0.05))',
              padding: '35px',
              borderRadius: '15px',
              borderRight: '5px solid var(--primary-orange)',
              marginBottom: '40px'
            }}>
            <p style={{
        fontSize: '1.15rem',
        lineHeight: '2',
        color: 'var(--text-light)',
        justifySelf: 'center',
        marginBottom: '20px'
      }}>
        في إطار حملة وطنية لمناهضة العنف ضد النساء والفتيات، تحمل هذه السنة شعار{' '}
        <strong style={{ color: 'var(--primary-orange)' }}>
          "العنف الذي تيسره التكنولوجيا ضد النساء والفتيات: جائحة رقمية صامتة تهدد المجتمع"
        </strong>{' '}
        ، ممتدة من 25 نونبر إلى 10 دجنبر 2025، ينظم المجلس الوطني لحقوق الإنسان معارض وأروقة تفاعلية بثلاث ساحات عمومية كبرى بمدينة الرباط.
      </p>


      <p style={{
        fontSize: '1.2rem',
        lineHeight: '2',
        color: 'var(--text-light)'
      }}>
        تمنح هذه الفضاءت المفتوحة للزوار تجربة تجمع بين التوعية والتحسيس والتفاعل والإنصات، بشكل يسلط الضوء على واحد من أكثر الانتهاكات الحقوقية، في شكلها الالكتروني والرقمي.
      </p>

            </div>
          </div>

          {/* Objectives Section */}
          <div style={{ marginBottom: '50px' }}>
            <h3 style={{
              fontSize: '2.3rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)'
            }}>
              تهدف هذه المبادرة إلى
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '25px'
            }}>
              {[

                {
                  icon: '🔒',
                  title: 'التحسيس والتفاعل',
                  desc: 'التفاعل مع المواطنات والمواطنين والتحسيس بخطورة العنف الرقمي ضد النساء والفتيات',
                },
                {
                  icon: '📚',
                  title: 'التعريف بأشكال العنف',
                  desc: 'التعريف بأشكال العنف الرقمي وآثاره'
                },
                {
                  icon: '🔔',
                  title: 'تشجيع التبليغ',
                  desc: 'تشجيع النساء والفتيات على التبليغ عن العنف الرقمي وكسر حاجز الصمت'
                }
              ].map((item, index) => (
                <div key={index} style={{
                  background: 'var(--primary-black)',
                  padding: '25px',
                  borderRadius: '15px',
                  border: '1px solid rgba(255, 107, 53, 0.3)',
                  transition: 'all 0.3s ease'
                }}>
                  <div style={{ fontSize: '2.5rem', marginBottom: '15px' }}>{item.icon}</div>
                  <h4 style={{ fontSize: '1.4rem', marginBottom: '12px', color: 'var(--primary-orange)' }}>
                    {item.title}
                  </h4>
                  <p style={{ fontSize: '1.05rem', lineHeight: '1.7', color: 'var(--text-light)' }}>
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Locations and Dates */}
          <div style={{ marginBottom: '50px' }}>
            <h3 style={{
              fontSize: '2.3rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)'
            }}>
              ندعوكن(م) لزيارة أروقة الحملة في المواعيد التالية
            </h3>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
              {[
                {
                  dates: '25–29 نونبر 2025',
                  location: 'محج الرياض، حي الرياض، الرباط',
                  icon: '📍'
                },
                {
                  dates: '30 نونبر – 4 دجنبر 2025',
                  location: 'أمام البرلمان',
                  icon: '🏛️'
                },
                {
                  dates: '5–9 دجنبر 2025',
                  location: 'محطة القطار الرباط أڭدال',
                  icon: '🚉'
                }
              ].map((item, index) => (
                <div key={index} style={{
                  background: 'var(--primary-black)',
                  padding: '30px',
                  borderRadius: '15px',
                  border: '2px solid var(--primary-orange)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '25px',
                  transition: 'all 0.3s ease'
                }}>
                  <div style={{
                    fontSize: '3rem',
                    minWidth: '60px',
                    textAlign: 'center'
                  }}>
                    {item.icon}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{
                      background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
                      padding: '10px 20px',
                      borderRadius: '10px',
                      fontWeight: '700',
                      fontSize: '1.2rem',
                      marginBottom: '15px',
                      display: 'inline-block'
                    }}>
                      {item.dates}
                    </div>
                    <h4 style={{
                      fontSize: '1.5rem',
                      color: 'var(--white)',
                      lineHeight: '1.6'
                    }}>
                      {item.location}
                    </h4>
                  </div>
                </div>
              ))}
            </div>
          </div>

    <div className="section-separator"></div>

          <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h3 style={{
              fontSize: '2.5rem',
              marginBottom: '25px',
              color: 'var(--white)'
            }}>
            انخرطوا معنا في الحملة الوطنية للحد من العنف الرقمي ضد النساء والفتيات
            </h3>

            <p style={{
              fontSize: '1.2rem',
              marginTop: '30px',
              color: 'var(--text-light)',
              fontStyle: 'italic'
            }}>
          مانسكتوش على العنف
            </p>
          </div>
        </div>
      </div>

  <Carousel />
    </div>
  );
}

export default Stands;
